module.exports = __webpack_public_path__ + "img/fangchan_bg2.6d933efa.png";